module.exports = __webpack_public_path__ + "img/teachCenter_logo.51d916a8.png";